export default "__VITE_ASSET__DuUqqSwE__"